<template>
    <svg
        id="LogoSvg"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        version="1.1"
        x="0px"
        y="0px"
        viewBox="0 0 65.9 23.4"
        style="enable-background: new 0 0 65.9 23.4"
        xml:space="preserve"
        height="48"
        width="136"
    >
        <g>
            <g>
                <path
                    class="st0"
                    d="M4.9,3.7c0-1.3,0.4-2,1.4-2s1.4,0.6,1.4,2v6.6c0,2.7-1.2,4-3.5,4c-1.9,0-3.1-0.9-3.1-2c0-0.7,0.5-1.3,1.3-1.3    c0.7,0,1.2,0.6,1.7,0.6c0.7,0,0.9-0.8,0.9-2.2L4.9,3.7L4.9,3.7z"
                />
                <path
                    class="st0"
                    d="M13.2,11.8c1.3,0,2.2-0.9,2.8-0.9c0.6,0,1.1,0.4,1.1,1c0,1.1-1.7,2.2-4,2.2c-2.6,0-4.6-2-4.6-4.7    s1.9-4.8,4.5-4.8s4.4,2,4.4,4.4c0,0.9-0.4,1.1-1.3,1.1h-4.8C11.3,11.2,12,11.8,13.2,11.8z M14.7,8.4c-0.1-0.9-0.8-1.6-1.7-1.6    c-0.9,0-1.6,0.6-1.8,1.6H14.7z"
                />
                <path
                    class="st0"
                    d="M18.9,7.4c-1,0-1.5-0.5-1.5-1.2S17.9,5.1,19,5V3.8c0-1.3,0.4-2,1.3-2s1.3,0.6,1.3,2V5h0.2    c1.1,0,1.7,0.5,1.7,1.2s-0.6,1.2-1.7,1.2h-0.1v4.7c0,1.3-0.4,2-1.3,2s-1.3-0.6-1.3-2V7.4C19,7.4,18.9,7.4,18.9,7.4z"
                />
                <path
                    class="st0"
                    d="M25.6,14.1c-0.9,0-1.4-0.6-1.4-2V3.8c0-1.3,0.4-1.9,1.9-1.9h2.5C31.4,1.9,33,3.5,33,6s-1.5,4.1-4.2,4.1H27    v2.1C27,13.4,26.6,14.1,25.6,14.1z M28.2,7.6c1.3,0,1.9-0.5,1.9-1.6s-0.6-1.6-1.9-1.6H27v3.2C27,7.6,28.2,7.6,28.2,7.6z"
                />
                <path
                    class="st0"
                    d="M37.5,14.1c-2.2,0-4.1-1.9-4.1-4.7c0-2.7,1.9-4.7,4.2-4.7c0.9,0,1.6,0.3,2.1,1C40,5.2,40.4,4.9,41,4.9    c0.9,0,1.3,0.6,1.3,1.9v5.4c0,1.3-0.4,2-1.3,2c-0.6,0-1-0.3-1.3-0.9C39.2,13.8,38.4,14.1,37.5,14.1z M37.9,11.6    c1,0,1.7-0.9,1.7-2.2s-0.7-2.1-1.7-2.1s-1.7,0.8-1.7,2.1S36.9,11.6,37.9,11.6z"
                />
                <path
                    class="st0"
                    d="M43.5,6.7c0-1.3,0.4-1.9,1.3-1.9c0.5,0,1,0.3,1.3,0.8c0.6-0.6,1.2-0.9,1.8-0.9c0.7,0,1.4,0.6,1.4,1.3    c0,1.1-1.2,1.2-2.3,1.7c-0.7,0.4-0.8,0.7-0.8,1.6v2.8c0,1.3-0.4,2-1.3,2s-1.3-0.6-1.3-2V6.7C43.6,6.7,43.5,6.7,43.5,6.7z"
                />
                <path
                    class="st0"
                    d="M54.9,5.5c0.5-0.5,0.9-0.7,1.4-0.7c0.6,0,1.1,0.5,1.1,1c0,0.4-0.3,0.9-0.7,1.3l-1.8,1.7l2.5,2.9    c0.4,0.4,0.5,0.8,0.5,1.3c0,0.6-0.5,1.1-1.3,1.1c-0.5,0-1-0.3-1.4-0.8l-2.7-3.6v2.4c0,1.3-0.4,2-1.3,2s-1.3-0.6-1.3-2V2.9    c0-1.3,0.4-2,1.3-2c0.9,0,1.3,0.6,1.3,2v4.9L54.9,5.5z"
                />
                <path
                    class="st0"
                    d="M58.2,12.2c0-0.7,0.5-1.2,1-1.2c0.8,0,1.6,0.8,2.5,0.8c0.5,0,0.7-0.3,0.7-0.5c0-0.4-0.5-0.6-1.5-1    c-1.6-0.7-2.5-1.3-2.5-2.7c0-1.6,1.4-2.9,3.3-2.9s3.1,0.9,3.1,1.9c0,0.6-0.5,1.1-1.1,1.1s-1.4-0.6-2.2-0.6c-0.4,0-0.6,0.2-0.6,0.5    c0,0.5,0.7,0.6,1.8,1.1c1.5,0.7,2.2,1.4,2.2,2.6c0,1.7-1.5,3.1-3.6,3.1C59.5,14.2,58.2,13.3,58.2,12.2z"
                />
            </g>
            <g>
                <path
                    class="st0"
                    d="M1,18.6c0-1.5,1-2.4,2.3-2.4c0.8,0,1.3,0.4,1.3,0.7c0,0.2-0.2,0.5-0.5,0.5s-0.5-0.1-1-0.1    c-0.7,0-1.1,0.5-1.1,1.5c0,0.8,0.5,1.3,1.2,1.3c0.5,0,0.7-0.2,1-0.2c0.2,0,0.4,0.2,0.4,0.5c0,0.4-0.6,0.8-1.5,0.8    C1.8,21,1,20,1,18.6z"
                />
                <path
                    class="st0"
                    d="M6.8,17.4c0.8,0,1.2,0.5,1.2,1.3v1.5c0,0.5-0.1,0.7-0.5,0.7S7,20.7,7,20.2V19c0-0.5-0.1-0.8-0.6-0.8    c-0.4,0-0.5,0.2-0.5,0.7v1.2c0,0.5-0.1,0.7-0.5,0.7s-0.5-0.2-0.5-0.7v-3.4C4.9,16.2,5,16,5.4,16s0.5,0.2,0.5,0.7v1    C6.1,17.5,6.3,17.4,6.8,17.4z"
                />
                <path
                    class="st0"
                    d="M10.2,20c0.5,0,0.8-0.4,1.1-0.4c0.2,0,0.4,0.1,0.4,0.4c0,0.4-0.6,0.8-1.6,0.8S8.3,20.1,8.3,19S9,17.2,10,17.2    s1.7,0.7,1.7,1.7c0,0.4-0.1,0.4-0.5,0.4H9.4C9.5,19.8,9.7,20,10.2,20z M10.7,18.8c0-0.4-0.4-0.6-0.6-0.6c-0.4,0-0.6,0.2-0.7,0.6    H10.7z"
                />
                <path
                    class="st0"
                    d="M13.4,21c-0.8,0-1.6-0.7-1.6-1.8s0.7-1.8,1.6-1.8c0.4,0,0.6,0.1,0.8,0.4c0.1-0.2,0.2-0.4,0.5-0.4    c0.4,0,0.5,0.2,0.5,0.7v2.1c0,0.5-0.1,0.7-0.5,0.7c-0.2,0-0.4-0.1-0.5-0.4C14.1,20.8,13.7,21,13.4,21z M13.6,20    c0.4,0,0.6-0.4,0.6-0.8c0-0.5-0.2-0.8-0.6-0.8S13,18.8,13,19.2C12.9,19.7,13.2,20,13.6,20z"
                />
                <path
                    class="st0"
                    d="M16.3,22.3c-0.4,0-0.5-0.2-0.5-0.7v-3.4c0-0.5,0.1-0.7,0.5-0.7c0.2,0,0.4,0.1,0.5,0.4    c0.2-0.2,0.5-0.4,0.8-0.4c0.8,0,1.6,0.7,1.6,1.8c0,1-0.7,1.8-1.6,1.8c-0.4,0-0.6-0.1-0.8-0.2v0.8C16.9,22.1,16.6,22.3,16.3,22.3z     M17.5,20c0.4,0,0.7-0.4,0.7-0.8c0-0.5-0.2-0.8-0.7-0.8c-0.4,0-0.7,0.4-0.7,0.8C16.9,19.7,17.1,20,17.5,20z"
                />
                <path
                    class="st0"
                    d="M22.2,20.5C22.1,20.9,22,21,21.7,21c-0.2,0-0.5-0.2-0.5-0.5c0-0.1,0-0.2,0-0.4l1.2-3.3    c0.1-0.5,0.4-0.7,0.8-0.7s0.6,0.2,0.7,0.6l1.2,3.3c0,0.1,0.1,0.2,0.1,0.4c0,0.2-0.2,0.5-0.5,0.5s-0.5-0.1-0.6-0.5L24,19.9h-1.7    L22.2,20.5z M23.8,19.1l-0.5-1.7l-0.6,1.7H23.8z"
                />
                <path
                    class="st0"
                    d="M26,15.9c0.4,0,0.6,0.2,0.6,0.6s-0.2,0.6-0.6,0.6c-0.4,0-0.6-0.2-0.6-0.6S25.7,15.9,26,15.9z M26,20.9    c-0.4,0-0.5-0.2-0.5-0.7v-2.1c0-0.5,0.1-0.7,0.5-0.7s0.5,0.2,0.5,0.7v2.1C26.6,20.6,26.3,20.9,26,20.9z"
                />
                <path
                    class="st0"
                    d="M27.1,18.1c0-0.5,0.1-0.7,0.5-0.7c0.2,0,0.4,0.1,0.5,0.4c0.2-0.2,0.5-0.4,0.7-0.4s0.5,0.2,0.5,0.5    c0,0.4-0.5,0.5-0.8,0.6c-0.2,0.1-0.4,0.2-0.4,0.6v1.1c0,0.5-0.1,0.7-0.5,0.7s-0.5-0.2-0.5-0.7V18.1z"
                />
                <path
                    class="st0"
                    d="M30,22.3c-0.4,0-0.5-0.2-0.5-0.7v-3.4c0-0.5,0.1-0.7,0.5-0.7c0.2,0,0.4,0.1,0.5,0.4c0.2-0.2,0.5-0.4,0.8-0.4    c0.8,0,1.6,0.7,1.6,1.8c0,1-0.7,1.8-1.6,1.8c-0.4,0-0.6-0.1-0.8-0.2v0.8C30.5,22.1,30.3,22.3,30,22.3z M31.1,20    c0.4,0,0.7-0.4,0.7-0.8c0-0.5-0.2-0.8-0.7-0.8c-0.4,0-0.7,0.4-0.7,0.8C30.5,19.7,30.7,20,31.1,20z"
                />
                <path
                    class="st0"
                    d="M34.7,17.4c1,0,1.7,0.7,1.7,1.8S35.7,21,34.7,21S33,20.3,33,19.2S33.7,17.4,34.7,17.4z M34.7,20    c0.4,0,0.7-0.4,0.7-0.8c0-0.5-0.2-0.8-0.7-0.8c-0.4,0-0.7,0.4-0.7,0.8C34.1,19.7,34.3,20,34.7,20z"
                />
                <path
                    class="st0"
                    d="M36.8,18.1c0-0.5,0.1-0.7,0.5-0.7c0.2,0,0.4,0.1,0.5,0.4c0.2-0.2,0.5-0.4,0.7-0.4s0.5,0.2,0.5,0.5    c0,0.4-0.5,0.5-0.8,0.6c-0.2,0.1-0.4,0.2-0.4,0.6v1.1c0,0.5-0.1,0.7-0.5,0.7s-0.5-0.2-0.5-0.7V18.1z"
                />
                <path
                    class="st0"
                    d="M39.6,18.3c-0.4,0-0.6-0.1-0.6-0.5c0-0.2,0.2-0.5,0.6-0.5v-0.5c0-0.5,0.1-0.7,0.5-0.7s0.5,0.2,0.5,0.7v0.5    h0.1c0.4,0,0.6,0.1,0.6,0.5c0,0.2-0.2,0.5-0.6,0.5l0,0v1.8c0,0.5-0.1,0.7-0.5,0.7s-0.5-0.2-0.5-0.7L39.6,18.3L39.6,18.3z"
                />
                <path
                    class="st0"
                    d="M43.9,20.9c-0.4,0-0.5-0.2-0.5-0.7V17c0-0.5,0.1-0.7,0.7-0.7h1c1.1,0,1.7,0.6,1.7,1.6s-0.6,1.6-1.6,1.6h-0.7    v0.8C44.5,20.6,44.3,20.9,43.9,20.9z M44.9,18.4c0.5,0,0.7-0.2,0.7-0.6s-0.2-0.6-0.7-0.6h-0.5v1.2H44.9z"
                />
                <path
                    class="st0"
                    d="M48.4,21c-0.8,0-1.6-0.7-1.6-1.8s0.7-1.8,1.6-1.8c0.4,0,0.6,0.1,0.8,0.4c0.1-0.2,0.2-0.4,0.5-0.4    c0.4,0,0.5,0.2,0.5,0.7v2.1c0,0.5-0.1,0.7-0.5,0.7c-0.2,0-0.4-0.1-0.5-0.4C49.1,20.8,48.8,21,48.4,21z M48.7,20    c0.4,0,0.6-0.4,0.6-0.8c0-0.5-0.2-0.8-0.6-0.8c-0.4,0-0.6,0.4-0.6,0.8C47.9,19.7,48.3,20,48.7,20z"
                />
                <path
                    class="st0"
                    d="M50.8,18.1c0-0.5,0.1-0.7,0.5-0.7c0.2,0,0.4,0.1,0.5,0.4c0.2-0.2,0.5-0.4,0.7-0.4s0.5,0.2,0.5,0.5    c0,0.4-0.5,0.5-0.8,0.6c-0.2,0.1-0.4,0.2-0.4,0.6v1.1c0,0.5-0.1,0.7-0.5,0.7s-0.5-0.2-0.5-0.7V18.1z"
                />
                <path
                    class="st0"
                    d="M55.1,17.6c0.1-0.2,0.4-0.2,0.5-0.2c0.2,0,0.5,0.1,0.5,0.4c0,0.1-0.1,0.4-0.2,0.5l-0.7,0.6l1,1.1    c0.1,0.1,0.2,0.4,0.2,0.5c0,0.2-0.2,0.4-0.5,0.4c-0.2,0-0.4-0.1-0.5-0.4l-1-1.3v1c0,0.5-0.1,0.7-0.5,0.7s-0.5-0.2-0.5-0.7v-3.4    c0-0.5,0.1-0.7,0.5-0.7s0.5,0.2,0.5,0.7v1.9L55.1,17.6z"
                />
                <path
                    class="st0"
                    d="M56.9,15.9c0.4,0,0.6,0.2,0.6,0.6s-0.2,0.6-0.6,0.6s-0.6-0.2-0.6-0.6C56.4,16.1,56.7,15.9,56.9,15.9z     M56.9,20.9c-0.4,0-0.5-0.2-0.5-0.7v-2.1c0-0.5,0.1-0.7,0.5-0.7s0.5,0.2,0.5,0.7v2.1C57.5,20.6,57.3,20.9,56.9,20.9z"
                />
                <path
                    class="st0"
                    d="M58,18.1c0-0.5,0.1-0.7,0.5-0.7c0.2,0,0.4,0.1,0.5,0.4c0.2-0.2,0.5-0.4,0.8-0.4c0.8,0,1.2,0.5,1.2,1.3v1.5    c0,0.5-0.1,0.7-0.5,0.7S60,20.7,60,20.2V19c0-0.5-0.1-0.8-0.6-0.8c-0.4,0-0.5,0.2-0.5,0.7v1.2c0,0.5-0.1,0.7-0.5,0.7    s-0.5-0.2-0.5-0.7C58,20,58,18.1,58,18.1z"
                />
                <path
                    class="st0"
                    d="M63,20.9c-0.8,0-1.5-0.7-1.5-1.8s0.7-1.8,1.6-1.8c0.4,0,0.6,0.1,0.8,0.4c0.1-0.2,0.2-0.4,0.5-0.4    c0.4,0,0.5,0.2,0.5,0.7v2.1c0,0.6,0,1.1-0.2,1.5c-0.2,0.5-0.8,0.7-1.6,0.7c-1,0-1.5-0.4-1.5-0.7c0-0.2,0.2-0.5,0.5-0.5    s0.6,0.2,1.1,0.2s0.8-0.4,0.8-0.8v-0.1C63.7,20.8,63.3,20.9,63,20.9z M63.2,20c0.4,0,0.7-0.4,0.7-0.8c0-0.5-0.2-0.8-0.7-0.8    c-0.4,0-0.7,0.4-0.7,0.8C62.6,19.7,62.8,20,63.2,20z"
                />
            </g>
        </g>
    </svg>
</template>

<style lang="postcss" scoped>
svg {
    .st0 {
        fill: white;
    }
}
</style>
